export const marketComponentsSelector = () => {

    const marketComboSelectorBtn = $('.market_combo_selector_btn');
    const marketComboSelectorSelect = $('.market_combo_selector_select');

    if (!marketComboSelectorBtn.length || !marketComboSelectorSelect.length) {
        return null;
    }

    marketComboSelectorBtn.on('click', function (e) {
        e.preventDefault();
        var $parent = $(this).parent();
        var $national = $parent.find('select').first();
        var $international = $parent.find('select').last();
        var url = unmaskpath($national.data('url'));

        if ($national.val().trim() === '') {
            if ($international.val().trim() === '') return;
            window.location = url + '/' + $international.val().trim();
        } else {
            if ($national.val().trim() === '') return;
            window.location = url + '/' + $national.val().trim();
        }
    });

    marketComboSelectorSelect.on('change', function () {
        //Desmarcar todos los demás selectores excepto este
        var $thisOne = $(this);
        $.each(marketComboSelectorSelect, function () {
            var $thisOther = $(this);
            if ($thisOther[0] !== $thisOne[0]) $(this).val('');
        });
    });
}
